import { defineAsyncComponent, reactive } from "vue";
import i18n from "../../../i18n";
import { createLoading } from "../../../utils/loading";
import { createPage } from "../../../utils/page";
import { createColumnInput } from "../../../components/table/c-table.logic";
import { addModal, removeModal, setIsLoading as setIsLoadingApp } from "../../../app.logic";
import { Button, Modal } from "ant-design-vue";
import lodash from "lodash";
import { modalStyleForm } from "../../../utils/constant";
import { base64ToFileModel } from "../../../utils/file";

const CIcon = defineAsyncComponent(() => import('../../../components/icon/CIcon'))
const ReportList = defineAsyncComponent(() => import('./ReportList'))
const ReportSignForm = defineAsyncComponent(() => import('./ReportSignForm'))

export const { isLoading, setIsLoading } = createLoading()

export const onClickReport = ({ callReport, data }) => {
    setIsLoadingApp(true);
    data.isLoading = true
    return callReport()
        .finally(() => {
            setIsLoadingApp(false)
            data.isLoading = false
        });
};

export const openModalReportSignForm = ({ props, onSignSignature, signatureFile, }) => {
    const refs = reactive({ form: null, isShow: true })
    const options = addModal({
        bind: lodash.merge(lodash.cloneDeep(modalStyleForm), {
            width: '600px',
            onCancel: () => {
                refs.isShow = false;
                removeModal({ options })
            },
            onOk: () => {
                refs.form.callOnClickModalOk()
                    .then((record) => {
                        Modal.confirm({
                            title: i18n.global.t('components.table.operatorAndPagination.youAreWant', { text: i18n.global.t('components.report.sign') }),
                            onOk: () => {
                                if (onSignSignature) {
                                    const fileModel = base64ToFileModel({ name: "signature.png", base64: record?.base64 });
                                    onSignSignature?.({ fileModel })
                                }
                                options.bind.onCancel()
                            }
                        });
                    })
            }
        }),
        render: () => {
            return !refs.isShow ? <span></span> :
                <ReportSignForm ref={(e) => { if (e) refs.form = e }} {...props} signatureFile={signatureFile}></ReportSignForm>
        }
    })
    return options
};

export const openModalReportList = ({ props, data }) => {
    return addModal({
        bind: lodash.merge(lodash.cloneDeep(modalStyleForm), {
            header: i18n.global.t('components.report.reports'),
            width: '600px',
            footer: null,
        }),
        render: () => <ReportList {...props} reports={data.reports}></ReportList>
    })
}

export const createColumns = ({ props, data }) => {
    const { reports } = props;
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("components.report.fileName"),
            dataIndex: "fileName",
        }),
        {
            visible: () => true,
            title: () => i18n.global.t("components.report.print"),
            dataIndex: "visible",
            sorter: false,
            width: 150,
            align: 'center',
            customRender: ({ record }) => <Button class="btn-primary m-1" size="small" disabled={record.disabled} onClick={() => onClickReport({...record, data})}>
                <CIcon file='pdf.svg'/> {i18n.global.t("button.print")}
            </Button>
        },
        {
            visible: () => reports?.some(d=>d?.onSignSignature),
            title: () => i18n.global.t("components.report.sign"),
            dataIndex: "visible",
            sorter: false,
            width: 150,
            align: 'center',
            customRender: ({ record }) => !record?.onSignSignature ? <span></span> : <Button class="btn-primary m-1" size="small" disabled={record.disabled} onClick={() => openModalReportSignForm({...record, data})}>
                <CIcon file='edit.svg'/> {i18n.global.t("components.report.sign")}
            </Button>
        }
    ]
    return columns
}

export const initData = ({ props, data }) => {
    data.isLoading = false
    data.columns = createColumns({ props, data })
    data.page = createPage({ data: props.reports?.filter(d=>d.visible?.()) })
    data.tableOptions = { search: { activeKey: null } }
    data.manages = []
    data.manageExtras = []
    data.rowActions = []
}
